import { useTranslation } from "react-i18next";
import { Button } from "antd";

import AppFooter from "../components/layout/AppFooter";
import AppHeader from "../components/layout/AppHeader";
import { usePageTitle } from "../utils/usePageTitle";

import "./NotFoundPage.css";

export const NotFoundPage = () => {
  const { t } = useTranslation();
  usePageTitle(t("notFound.title"));

  const mailtoHref = `mailto:info@nextgis.com?subject=Non-existent page on nextgis.com&body=Action on the website led me to a 404 page: ${window.location.href}`;

  return (
    <div className="not-found-page">
      <AppHeader minimal />
      <div className="not-found-page__body">
        <div className="not-found-page__number">404</div>
        <h2>{t("notFound.title")}</h2>
        <p className="not-found-page__description">
          {t("notFound.description")}{" "}
          <a href={mailtoHref}>{t("notFound.letUsKnow")}</a>.
        </p>
        <Button
          type="primary"
          size="large"
          onClick={() => window.history.back()}
        >
          {t("app.goBack")}
        </Button>
      </div>
      <AppFooter variant="dark" />
    </div>
  );
};
